import { ProjectAppTypes, useEnvProvider } from '@bechtel/client-common';
import { Weld } from '@bechtel/types';

/**
 * Determines whether the "Send Back to Piping" option should be shown for a weld.
 *
 * In the ArcStryker (AS) app, a weld can only be sent back to Piping when its
 * work package discipline still has an active PipeFighter (PF) mapping. If the
 * weld does not exist in PipeFighter, the Piping send-back option is hidden.
 *
 * For all other apps (e.g. PipeFighter) the option is always shown.
 */
export function useShowSendBackToPiping(weld?: Pick<Weld, 'workPackage'> | null): boolean {
  const { envConfig } = useEnvProvider();
  const isASAppType = envConfig.appName === ProjectAppTypes.AS;

  if (isASAppType && weld?.workPackage?.existsInPipeFighter === false) {
    return false;
  }

  return true;
}
